// extracted by mini-css-extract-plugin
export default {"Avaliacao":"Avaliacao_Avaliacao__jmh-2","imgAvaliacao":"Avaliacao_imgAvaliacao__Er4CB","campotexto":"Avaliacao_campotexto__DrfGi","divimg":"Avaliacao_divimg__NQnyb"};